import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function changeLeadTemperatureById({body}) {
    try {
        const response = await axios.post(`${LEADS_ENDPOINT}/changeTemperature`, body)
        return response.data.data
    } catch (error) {
        console.log('error', error)
        throw new Error(error)
    }
}
